import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';

@Injectable({
  providedIn: 'root',
})
export abstract class ResourceService<T> {
  private readonly ApiUrl = this.getResourceUrl();
  private readonly EntitySetName = this.getEntitySetName();
  odataService: ODataEntitySetService<T>;

  constructor(
    protected factory: ODataServiceFactory,
    protected http: HttpClient
  ) {
    this.odataService = this.factory.entitySet<T>(this.EntitySetName);
  }

  httpOptions = {
    headers: new HttpHeaders({}),
  };

  abstract getResourceUrl(): string;
  abstract getEntitySetName(): string;

  public get odata(): ODataEntitySetService<T> {
    return this.odataService;
  }

  public count(query: string): Observable<number> {
    const url = `${this.getResourceUrl()}api/v1/${this.getEntitySetName()}/$count?${query}`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      map((res: string) => Number(res))
    );
  }
}
